import { Typography } from '@mui/material'
import { ContentWrapper } from '../..'
import { useUserRenderWrapper } from '../../../hooks'
import { UserInfo } from '../../../utils/classes/graphql'
import { TopBarUserVisibilityType } from '../types'

interface TopBarUserNameProps {
  user: UserInfo
  isMobile: boolean
}

const TopBarUserName = ({ user, isMobile }: TopBarUserNameProps) => {
  const kutsumanimi = user.nimi?.kutsumanimi
  const sukunimi = user.nimi?.sukunimi
  return (
    <Typography>
      {isMobile ? (
        kutsumanimi + ' ' + sukunimi
      ) : (
        <>
          <span>{kutsumanimi} </span>
          <span>{sukunimi}</span>
        </>
      )}
    </Typography>
  )
}

type TopBarUserContextWrapperProps = Pick<TopBarUserNameProps, 'isMobile'>

export const TopBarUserContextWrapper = ({
  isMobile
}: TopBarUserContextWrapperProps) => {
  const { UserRenderWrapper, user } = useUserRenderWrapper()

  return (
    <UserRenderWrapper>
      {user && <TopBarUserName user={user} isMobile={isMobile} />}
    </UserRenderWrapper>
  )
}

type TopBarUserNameWrapperProps = TopBarUserContextWrapperProps &
  TopBarUserVisibilityType

export const TopBarUserNameWrapper = ({
  isMobile,
  showUserName
}: TopBarUserNameWrapperProps) => (
  <ContentWrapper showContent={showUserName}>
    <TopBarUserContextWrapper isMobile={isMobile} />
  </ContentWrapper>
)
